import React from 'react';
import { Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import QuestionnairePage from './components/QuestionnairePage';
import ThankYouPage from './components/ThankYouPage';

const App = () => (
  <Routes>
    <Route path="/" element={<LoginPage />} />
    <Route path="/questionnaire" element={<QuestionnairePage />} />
    <Route path="/thankyou" element={<ThankYouPage />} />
  </Routes>
);

export default App;